import {Inject, Injectable} from '@angular/core';
import {select, Store} from "@ngrx/store";
import {selectChatIsOpen} from "./chat.state";
import {ChatActions} from "./chat.actions";
import {Conversation} from "@twilio/conversations";

@Injectable()
export class ChatFacadeService {

  constructor(@Inject(Store) private store: Store<any>) {

  }

  selectIsOpen() {
    return this.store.pipe(select(selectChatIsOpen));
  }

  setIsOpen(isOpen: boolean) {
    this.store.dispatch(ChatActions.setIsOpen({isOpen: isOpen}));
  }

  // selectConversation() {
  //   return this.store.pipe(select(selectChatIsOpen));
  // }
  //
  // setConversation(conversation: Conversation) {
  //   this.store.dispatch(ChatActions.setConversation({conversation: conversation}));
  // }

  // setUnreadCount() {
  //   this.store.dispatch(ChatActions.setUnreadCount({isOpen: isOpen}));
  // }

}
